import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import FlipMove from 'react-flip-move';
import { connect } from 'react-redux';

import {
    chapterSelector,
    chapterMemberSelector,
    authSelector
} from '../redux/selectors'

import {openChapters, toArray} from '../common/util';
import {hasPermission} from "../common/permissions";
import {closeChapter, fetchChapterMembers, openChapter} from "../redux/actions";
import ChaptersForm from "./ChaptersForm";

class Chapters extends Component {
    componentDidMount() {
        document.title = "Addiction | Guild Management | Chapters";
        openChapters(this.props.chapters)
            .map((chapter) => {
                this.props.getChapterMembers(chapter.id);
                return null;
            });
    }

    closeChapter = (chapter) => {
        if (hasPermission('games.close_chapter', this.props.auth.permissions)) {
            this.props.closeChapter(chapter)
        }
    };
    openChapter = (values) => {
       if (hasPermission('games.add_chapter', this.props.auth.permissions)) {
            let launchArray = values.launch.split('/');
            let launchDate = new Date(launchArray[0], launchArray[1]-1, launchArray[2]).toISOString();
            this.props.openChapter(values.title, launchDate)
        }
    };

    render() {
        const openChapters = toArray(this.props.chapters)
            .sort((a, b) => (new Date(b.openDate).getTime() - new Date(a.openDate).getTime()))
            .filter(chapter => chapter.closeDate === null)
            .map((chapter) => (
            <div key={`${chapter.id}-news`} className="panel-adt clearfix">
                <h2>{chapter.game.title}</h2>
                { chapter.game.title !== 'Addiction' ?
                    (
                    <h3 className="pull-right fake-link" onClick={() => this.closeChapter(chapter.id)}>Close
                        Chapter</h3>
                    ): (null)
                }
                <div>{toArray(this.props.chapterMembers.data).filter(member => member.chapter === chapter.id).filter(member => member.leaveDate === null).length} Members</div>
            </div>
        ));
        const closedChapters = toArray(this.props.chapters)
            .sort((a, b) => (new Date(b.openDate).getTime() - new Date(a.openDate).getTime()))
            .filter(chapter => chapter.closeDate !== null)
            .map((chapter) => (
            <div key={`${chapter.id}-news`} className="panel-adt">
                <div style={{opacity:"0.7"}}>
                    <h2>{chapter.game.title}</h2>
                </div>
            </div>
        ));
        if (hasPermission('games.add_chapter', this.props.auth.permissions) || hasPermission('games.close_chapter', this.props.auth.permissions)) {
            return (
                <div>
                    <h1>Chapter Management</h1>
                    <div className="panel-adt">
                        <h3>Open New Chapter</h3>
                        <ChaptersForm
                            onSubmit={this.openChapter}
                            errors={this.props.auth.registerError}
                        />
                    </div>
                    <FlipMove
                        staggerDelayBy={50}
                        appearAnimation="fade"
                        enterAnimation="fade"
                        leaveAnimation="fade"
                        className="news"
                    >
                        {openChapters}
                        {closedChapters}
                    </FlipMove>
                </div>
            )
        } else {
            return <Redirect to="/" />
        }
    }
}

const mapStateToProps = (state) => ({
    auth: authSelector(state),
    chapters: chapterSelector(state),
    chapterMembers: chapterMemberSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    getChapterMembers: (chapter) => dispatch(fetchChapterMembers(chapter)),
    closeChapter: (chapter) => dispatch(closeChapter(chapter)),
    openChapter: (title, launch) => dispatch(openChapter(title, launch))
});

export default connect(mapStateToProps, mapDispatchToProps)(Chapters);


// WEBPACK FOOTER //
// ./src/Officer/Chapters.js